function coerceErrorText(value: unknown): string | null {
  if (value == null || value === '') return null;
  if (typeof value === 'string' && value.trim()) return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (value instanceof Error) {
    return value.message?.trim() || null;
  }
  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const message = obj.message;
    if (Array.isArray(message)) {
      const parts = message.filter(
        (part) => typeof part === 'string' && part.trim(),
      ) as string[];
      return parts.length > 0 ? parts.join(', ') : null;
    }
    if (typeof message === 'string' && message.trim()) {
      return message.trim();
    }
    if (typeof obj.error === 'string' && obj.error.trim()) {
      return obj.error.trim();
    }
  }
  return null;
}

/** Readable toast/detail text from HttpErrorResponse or legacy `{ status, error }` bodies. */
export function formatApiErrorDetail(
  error?: unknown,
  fallback = 'Something went wrong.',
  responseError?: unknown,
): string {
  if (responseError != null && responseError !== '') {
    const fromResponse = coerceErrorText(responseError);
    if (fromResponse) return fromResponse;
  }
  if (error != null) {
    const http = error as { error?: unknown; message?: string };
    if (http.error != null) {
      const nested = coerceErrorText(http.error);
      if (nested) return nested;
    }
    if (typeof http.message === 'string' && http.message.trim()) {
      return http.message.trim();
    }
    const direct = coerceErrorText(error);
    if (direct) return direct;
  }
  return fallback;
}
